import {IDS} from '../tasks-action-id.constants';
import {TYPES} from "../tasks-action-type.constants";
import * as Actions from '../tasks.actions';
import * as RcoActions from '../../accreditation.actions';
import * as EvidenceGroupDetailsActions from '../../requirements-assessment/evidence-group-details/evidence-group-details.actions';
import {GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";
import I18N from "../../../../common/utils/util.i18n";
import {submitEvidenceReviewOrDocRevision, submitImprovementActionStepForCompletion} from "../tasks.actions";
class AccTasksDetailsController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $filter,
                $timeout,
                Notifier,
                DocumentManager,
                EmployeeService,
                FileActions,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.FileActions = FileActions;
        this.identifier = IDS.accTasks;
        this.$scope = $scope;
    }

    $onInit() {
        this.schemeCode         = this.$stateParams.itemCode;
        this.adoId              = this.$stateParams.ado;
        this.sloFiscalYear      = this.$stateParams.year;

        this.unsubscribe = this.$ngRedux.connect(state => {
            const subModule = state.accreditation[this.identifier];
            const details = subModule.taskDetails;
            if(!details?.id)
                return {}
            details.doc_new_version = details.doc_new_version || 1;
            const isStepTask = details.uta_type === 'utimas';
            const isStepTaskLinkedToEvidence = isStepTask && details.ard_id
            return {
                details,
                includedRequirements: details.includedRequirements,
                notIncludedRequirements: details.notIncludedRequirements,
                isStepTask,
                isStepTaskLinkedToEvidence,
                improvementAction: subModule.improvementAction,
                requirementName: get(details, 'requirements[0].name'),
                requirementDescription: get(details, 'requirements[0].description'),
                isEvidenceOrDocumentTask: ['utrcdr','utrcer'].includes(details.uta_type),
                status: I18N.translate(`ACCREDITATION.${isStepTask ? 'IMPROVEMENT.STEP_STATUS' : 'EVIDENCE.STATUS'}.${details?.status_code?.toUpperCase()}`) || details?.status_code,
                isTaskCompleted: details?.status_code === 'cpl',
                noDocumentsUploaded: !state.accreditation[this.identifier][IDS.rcoEvidenceGroupDocumentsGrid].items?.length,
                titlePrefix: I18N.translate(`ACCREDITATION.TASKS.DETAILS.TITLE_PREFIX.${details?.uta_type.toUpperCase()}`, details?.utaTypeName),
                statusStyle: {
                    color: {'pen':'red','sub':'green','cpl':'green'}[details.status_code],
                    // 'background-color': {'sub':'black','cpl':'gray'}[details.status_code],
                },
                firstDocType: state.accreditation.common.documentTypes[0].value,
                submitButtonLabel:
                    details.uta_type === 'utrcdr' ? 'Submit Revision'
                    : details.includedRequirements.some(i => i.confirmed !== 1) ? 'Save Review Progress' : 'Submit Review'
            }
        }, {
            ...RcoActions,
            ...EvidenceGroupDetailsActions,
            ...Actions,
            ...this.FileActions,
        })(this);

        this.updateUploadPanel();
    }

    onSubmitReviewOrRevisionButton() {
        // if (this.details.uta_type === 'utrcer' && this.includedRequirements.some(item => item.required && !item.confirmed)) {
        //     this.Notifier.error('Please mark all requirements as confirmed before submitting the review');
        //     return;
        // }
        this.submitEvidenceReviewOrDocRevision(
            this.details.uta_id,
            this.details.uta_type === 'utrcer' ? this.includedRequirements : []
        ).then(() => {
            this.Notifier.success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.accTasksGrid,
            });
            this.fetchTaskDetails(this.details.uta_id).then(data => {
                this.$ngRedux.dispatch({
                    type: TYPES.TASK_DETAILS_REFRESH,
                    id: IDS.accTasks,
                    data,
                    firstDocType: this.firstDocType,
                });
            });
        });
    }

    onSubmitImprovementStepCompletion() {
        const form = this.$scope.taskDetailsForm;
        if(form.$invalid) {
            this.Notifier.error('Please fill in the form fields');
            return;
        }
        this.submitImprovementActionStepForCompletion(this.details.uta_id, this.details.comment).then(() => {
            this.Notifier.success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.accTasksGrid,
            });
            this.fetchTaskDetails(this.details.uta_id).then(data => {
                this.$ngRedux.dispatch({
                    type: TYPES.TASK_DETAILS_REFRESH,
                    id: IDS.accTasks,
                    data,
                    firstDocType: this.firstDocType,
                });
                form.$setPristine();
                form.$setUntouched();
            });
            this.fetchTaskDetails(this.details.par_id, 'utimca').then(data => {
                data.statusName = I18N.translate(`ACCREDITATION.TASKS.STATUS.${data.status_code.toUpperCase()}`, data.status_code);
                this.$ngRedux.dispatch({
                    type: TYPES.IMPROVEMENT_ACTION_REFRESH,
                    id: IDS.accTasks,
                    data,
                });
            });
        });
    }
    onRequirementConfirmationChange(index, {input}) {
        // const {ase_id} = this.includedRequirements[index];
        // this.updateEvidenceRequirementConfirmation(this.details?.id, ase_id, input || 0)
    }

    onUpdateGridButton({item}) {
        this.selectedDocumentUuid = item.id;
        this.selectedDocumentName = item.name;
        this.updateUploadPanel();
    }

    onCancelUpdateButton() {
        this.selectedDocumentUuid = null;
        this.selectedDocumentName = null;
        this.updateUploadPanel();
    }

    onRemoveGridButton({item}) {
        this.removeDocumentFromEvidenceGroup({
            vdo_uuid: item.id,
            evg_id: this.details.ard_id,
            slo_uuid: this.details.location_uuid,
            requirement_id: this.details.requirements[0]?.ase_id
        }).then(() => {
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.rcoEvidenceGroupDocumentsGrid
            });
        });
    }

    onDownloadButton() {
        this.download(`storage${this.details.doc_url}`);
    }

    onUploadSave(event,ctrl) {
        if(this.isTaskCompleted)
            return

        if(!this.selectedDocumentUuid){

            const form = this.$scope.addNewDocumentForm;
            if(form.$invalid) {
                this.Notifier.error('Please fill in the form fields');
                return;
            }
        }
        const details = this.details;

        this.addDocumentVersion({
            ard_id:     details.ard_id,
            vdo_uuid:   this.selectedDocumentUuid,
            slo_uuid:   details.location_uuid,
            file_path:  event[0].filePath,
            // uta_id:     details.uta_id, // review task to be completed
            doc_version:this.selectedDocumentUuid? undefined : details.doc_new_version || 1, // if new version is not specified, default to 1
            name:       this.selectedDocumentUuid? undefined : details.name,
            doc_num:    this.selectedDocumentUuid? undefined : details.doc_num,
            doc_type:   details.doc_type,
        }).then(({params}) =>{
            this.onCancelUpdateButton();
            this.$ngRedux.dispatch({
                type: TYPES.SAVE_UPLOADED_DOCUMENT,
                id: IDS.accTasks,
                path: IDS.accTasks,
                filePath: event[0].filePath,
                doc_id: params.id,
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.accTasks,
                path: IDS.rcoEvidenceGroupDocumentsGrid
            });
        })
    }

    onDownloadSampleButton() {
        this.download(`storage${this.details.sample_doc_url}`);
    }

    updateUploadPanel() {
        this.hideNewDocDetails = this.isDocumentGeneratable || !!this.selectedDocumentUuid;
        this.uploadButtonLabel = this.$filter('translate')(`COMMON.BUTTON.${this.selectedDocumentUuid ? 'UPLOAD_NEW_VERSION' : 'ADD_DOCUMENT'}`);
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

AccTasksDetailsController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$filter',
    '$timeout',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'FileActions',
    '$scope']

export const accTasksDetails = {
    controller: AccTasksDetailsController,
    template: require('./details.html')
}
